import {CSSProperties, useEffect, useState} from 'react'
import _ from 'lodash'
import {useMeasure} from 'react-use'
import {Select} from 'semantic-ui-react'
import {ILabelingWidgetConfig, ILabelingWidgetProps} from '..'
import V1 from './images/v1.jpg'
import V2 from './images/v2.jpg'
import V3 from './images/v3.jpg'
import V4 from './images/v4.jpg'
import V5 from './images/v5.jpg'
import A1 from './images/a1.jpg'
import A2 from './images/a2.jpg'
import A3 from './images/a3.jpg'
import A4 from './images/a4.jpg'
import A5 from './images/a5.jpg'
import D1 from './images/d1.jpg'
import D2 from './images/d2.jpg'
import D3 from './images/d3.jpg'
import D4 from './images/d4.jpg'
import D5 from './images/d5.jpg'
import './style.css'

export interface IVadLabel {
  v: number
  a: number
  d: number
  emotions: (typeof emotionNames)[number][]
}

const emotionNames = ['anger', 'disgust', 'enjoyment', 'fear', 'sadness', 'surprise'] as const
type EmotionName = (typeof emotionNames)[number]
const emotionNameOptions = _.map(emotionNames, (emotion) => ({text: emotion, value: emotion}))

const options: [keyof IVadLabel, string[]][] = [
  ['v', [V1, V2, V3, V4, V5]],
  ['a', [A1, A2, A3, A4, A5]],
  ['d', [D1, D2, D3, D4, D5]],
]

function LabelingWidget(props: ILabelingWidgetProps<IVadLabel>) {
  const {currentLabelData, disabled, setCurrentLabelData} = props

  const [measureRef, {width, height}] = useMeasure<HTMLDivElement>()
  const [imgSize, setImgSize] = useState<number>(120)
  const [state, setState] = useState<Partial<IVadLabel>>()

  useEffect(() => {
    if (!width) return
    setImgSize(width / 5)
  }, [width, height])

  useEffect(() => {
    setState(currentLabelData)
  }, [currentLabelData])

  useEffect(() => {
    if (!state) return
    if (state.v === undefined) return
    if (state.a === undefined) return
    if (state.d === undefined) return
    if (!(state.emotions && state.emotions.length > 0)) return
    if (_.isEqual(currentLabelData, state)) return
    setCurrentLabelData({
      v: state.v,
      a: state.a,
      d: state.d,
      emotions: state.emotions,
    })
  }, [state])

  return (
    <div
      ref={measureRef}
      className='labeling-widget vad'
    >
      <Select
        multiple
        className='vad-emotions'
        labeled
        disabled={disabled}
        placeholder='select emotion(s)'
        error={(state?.emotions || []).length === 0}
        value={state?.emotions || []}
        onChange={(_e, {value}) => {
          setState((prev) => ({
            ...prev,
            emotions: value as EmotionName[],
          }))
        }}
        options={emotionNameOptions}
      />
      <div className='vad-images'>
        {_.map(options, ([key, images]) => {
          return (
            <div
              key={key}
              className='row'
              style={{
                height: `${imgSize}px`,
              }}
            >
              {_.map(images, (img, i) => {
                const score = i + 1
                const style: CSSProperties = {
                  width: `${imgSize}px`,
                  backgroundImage: `url(${img})`,
                }
                const classNames = _.chain([
                  'img',
                  state && state[key] === score ? 'active' : undefined,
                  disabled ? 'disabled' : undefined,
                ])
                  .compact()
                  .join(' ')
                  .value()
                return (
                  <div
                    key={i}
                    className={classNames}
                    style={style}
                    onClick={() => {
                      if (disabled) return
                      setState((prev) => ({
                        ...prev,
                        [key]: score,
                      }))
                    }}
                  />
                )
              })}
            </div>
          )
        })}
      </div>
    </div>
  )
}

export const labelingWidgetConfigVad: ILabelingWidgetConfig<IVadLabel> = {
  canDelete: true,
  control: LabelingWidget,
  // computeLabelStyle: computeLabelStyle,
}
